
import { defineComponent, computed } from 'vue'
import { useStore } from '@/composables/use-store'
import { ConnectionStatus } from '@/types/events'

export default defineComponent({
  name: 'SocketStatus',
  setup () {
    const store = useStore()
    const status = computed<ConnectionStatus>(() =>
      store.getters['global/socketStatus']
    )

    return {
      status
    }
  }
})
